// "use client";
// import React, { useState } from "react";
// import { Box, Container, Typography, Card, CardContent, Button } from "@mui/material";
// import { useRouter } from "next/navigation";
// import { useTranslation } from "react-i18next";
// import Image from "next/image";
// import RecruiterFeedback from "./RecruiterFeedback";
// import "../app/globals.css";
// import { IMAGES } from "../constants/images";
// import HiringProcess from "./HiringProcess";
// import NextLink from "next/link";
// const FeaturesGrid = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const router = useRouter();
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";

//   const gridItems = [
//     {
//       id: 1,
//       iconImg: IMAGES.FEATURE_ICON_1,
//       label: t("featuresGrid.items.aiRecruiter"),
//     },
//     {
//       id: 2,
//       iconImg: IMAGES.FEATURE_ICON_2,
//       label: t("featuresGrid.items.evaluationEngine"),
//     },
//     {
//       id: 3,
//       iconImg: IMAGES.FEATURE_ICON_3,
//       label: t("featuresGrid.items.aiScreening"),
//     },
//     {
//       id: 4,
//       iconImg: IMAGES.FEATURE_ICON_4,
//       label: t("featuresGrid.items.candidateMatchmaking"),
//     },
//     {
//       id: 5,
//       iconImg: IMAGES.FEATURE_ICON_5,
//       label: t("featuresGrid.items.aiCandidateScoring"),
//     },
//     {
//       id: 6,
//       iconImg: IMAGES.FEATURE_ICON_6,
//       label: t("featuresGrid.items.multilingualInterviews"),
//     },
//     {
//       id: 7,
//       iconImg: IMAGES.FEATURE_ICON_7,
//       label: t("featuresGrid.items.interviewSummaries"),
//     },
//     {
//       id: 8,
//       iconImg: IMAGES.FEATURE_ICON_8,
//       label: t("featuresGrid.items.customInterviews"),
//     },
//     {
//       id: 9,
//       iconImg: IMAGES.FEATURE_ICON_9,
//       label: t("featuresGrid.items.customBranding"),
//     },
//     {
//       id: 10,
//       iconImg: IMAGES.FEATURE_ICON_10,
//       label: t("featuresGrid.items.advancedAnalytics"),
//     },
//     {
//       id: 11,
//       isSpecial: true,
//       image: isArabic
//         ? IMAGES.EVALUATION_ENGINE_ARABIC
//         : IMAGES.EVALUATION_ENGINE,
//       title: "Evaluation Engine",
//     },
//     {
//       id: 12,
//       isSpecial: true,
//       image: isArabic
//         ? IMAGES.AI_RECRUITER_FEATURE_ARABIC
//         : IMAGES.AI_RECRUITER_FEATURE,
//       title: "AI Recruiter",
//     },
//     {
//       id: 13,
//       iconImg: IMAGES.FEATURE_ICON_11,
//       label: t("featuresGrid.items.emailAutomation"),
//     },
//     {
//       id: 14,
//       iconImg: IMAGES.FEATURE_ICON_12,
//       label: t("featuresGrid.items.careersPage"),
//     },
//     {
//       id: 15,
//       iconImg: IMAGES.FEATURE_ICON_13,
//       label: t("featuresGrid.items.bulkHiring"),
//     },
//     {
//       id: 16,
//       iconImg: IMAGES.FEATURE_ICON_14,
//       label: t("featuresGrid.items.assessmentLibrary"),
//     },
//     {
//       id: 17,
//       iconImg: IMAGES.FEATURE_ICON_15,
//       label: t("featuresGrid.items.interviewScheduling"),
//     },
//     {
//       id: 18,
//       iconImg: IMAGES.FEATURE_ICON_16,
//       label: t("featuresGrid.items.mobileOptimization"),
//     },
//     {
//       id: 19,
//       iconImg: IMAGES.FEATURE_ICON_17,
//       label: t("featuresGrid.items.recruitingAnalytics"),
//     },
//     {
//       id: 20,
//       iconImg: IMAGES.FEATURE_ICON_18,
//       label: t("featuresGrid.items.customAutomations"),
//     },
//     {
//       id: 21,
//       iconImg: IMAGES.FEATURE_ICON_20,
//       label: t("featuresGrid.items.calendarIntegration"),
//     },
//     {
//       id: 22,
//       iconImg: IMAGES.FEATURE_ICON_21,
//       label: t("featuresGrid.items.antiCheating"),
//     },
//     {
//       id: 23,
//       iconImg: IMAGES.FEATURE_ICON_22,
//       label: t("featuresGrid.items.referenceChecking"),
//     },
//     {
//       id: 24,
//       iconImg: IMAGES.FEATURE_ICON_23,
//       label: t("featuresGrid.items.backgroundVerification"),
//     },
//     {
//       id: 25,
//       iconImg: IMAGES.FEATURE_ICON_24,
//       label: t("featuresGrid.items.customEmails"),
//     },
//     {
//       id: 26,
//       iconImg: IMAGES.FEATURE_ICON_25,
//       label: t("featuresGrid.items.offerLetter"),
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundImage: `url('${IMAGES.FEATURES_GRID_BG}')`,
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         direction: isArabic ? "rtl" : "ltr",
//       }}
//     >
//       <Container maxWidth="xxl">
//         {/* Header */}
//         <Box
//           sx={{
//             textAlign: {
//               xs: "left",
//               sm: "left",
//               md: "left",
//               lg: "center",
//               xl: "center",
//             },
//             mb: { xs: 3, sm: 4, md: 5, lg: 8 },
//             px: { xs: 2, sm: 3, md: 0 },
//           }}
//         >
//           {/* <Typography
//             variant="h3"
//             sx={{
//               fontSize: {
//                 xs: "22px",
//                 sm: "26px",
//                 md: "32px",
//                 lg: "40px",
//                 xl: "48px",
//               },
//               fontWeight: 700,
//               lineHeight: 1.3,
//               color: "#020617",
//               mb: { xs: 1, sm: 1.2, md: 1.5 },
//               fontFamily: "var(--font-plusjakarta)",
//               pt: { xs: "8%", sm: "7%", md: "6%", lg: "6%" },
//               textAlign: {
//                 xs: "left",
//                 sm: "left",
//                 md: "left",
//                 lg: "center",
//                 xl: "center",
//               },
//             }}
//           >
//             {isArabic ? (
//               <>
//                 {"...و"}
//                 <Box component="span" sx={{ color: "#9048FB" }}>
//                   {"أكثر "}
//                 </Box>
//                 {"من ذلك بكثير"}
//               </>
//             ) : (
//               <>
//                 {"and "}
//                 <Box component="span" sx={{ color: "#9048FB" }}>
//                   {"much "}
//                 </Box>
//                 {"more"}
//                 <span style={{ color: "#9048FB" }}>{"..."}</span>
//               </>
//             )}
//           </Typography> */}
//           <Typography
//             variant="h3"
//             sx={{
//               fontSize: {
//                 xs: "22px",
//                 sm: "26px",
//                 md: "32px",
//                 lg: "40px",
//                 xl: "48px",
//               },
//               fontWeight: 700,
//               lineHeight: isArabic ? 1.6 : 1.3,
//               color: "#020617",
//               mb: { xs: 1, sm: 1.2, md: 1.5 },
//               fontFamily: "var(--font-plusjakarta)",
//               pt: { xs: "8%", sm: "7%", md: "6%", lg: "6%" },
//               textAlign: {
//                 xs: isArabic ? "right" : "left",
//                 sm: isArabic ? "right" : "left",
//                 md: isArabic ? "right" : "left",
//                 lg: "center",
//                 xl: "center",
//               },
//               "& span": { color: "inherit" },
//             }}
//           >
//             {isArabic ? (
//               <>
//                 <span style={{ color: "#9048FB", fontStyle: "normal" }}>
//                   {"و"}
//                 </span>{" "}
//                 <span
//                   style={{
//                     color: "#9048FB",
//                     fontStyle: "normal",
//                     WebkitTextFillColor: "#9048FB",
//                     background: "none",
//                   }}
//                 >
//                   {"أكثر"}
//                 </span>{" "}
//                 <span style={{ color: "#020617", fontStyle: "normal" }}>
//                   {"من ذلك بكثير"}
//                 </span>{" "}
//                 <span style={{ color: "#020617" }}>{"."}</span>
//                 <span
//                   style={{
//                     color: "#9048FB",
//                     WebkitTextFillColor: "#9048FB",
//                     background: "none",
//                   }}
//                 >
//                   {"."}
//                 </span>
//                 <span style={{ color: "#020617" }}>{"."}</span>
//               </>
//             ) : (
//               <>
//                 <span style={{ color: "#020617" }}>{"."}</span>
//                 <span
//                   style={{
//                     color: "#9048FB",
//                     WebkitTextFillColor: "#9048FB",
//                     background: "none",
//                   }}
//                 >
//                   {"."}
//                 </span>
//                 <span style={{ color: "#020617" }}>{"."}</span>
//                 {" and "}
//                 <span
//                   style={{
//                     color: "#9048FB",
//                     WebkitTextFillColor: "#9048FB",
//                     background: "none",
//                   }}
//                 >
//                   {"much "}
//                 </span>
//                 <span style={{ color: "#020617" }}>{"more"}</span>
//               </>
//             )}
//           </Typography>
//           <Typography
//             sx={{
//               color: "#02061799",
//               mb: 0.7,
//               fontWeight: "400",
//               fontSize: {
//                 xs: "14px",
//                 sm: "15px",
//                 md: "17px",
//                 lg: "20px",
//                 xl: "22px",
//               },
//               fontFamily: "var(--font-outfit)",
//               mx: { xs: 0, sm: 0, md: 0, lg: "auto" },
//               textAlign: isArabic
//                 ? { xs: "right", lg: "center" }
//                 : { xs: "left", lg: "center" },
//               maxWidth: { xs: "100%", lg: 900 },
//               mt: { xs: isArabic ? "3%" : ".5%", sm: ".5%" },
//               lineHeight: 1.4,
//             }}
//           >
//             {t("featuresGrid.subtitle")}
//           </Typography>
//         </Box>

//         {/* Grid Section */}
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: {
//               xs: "repeat(2, 1fr)",
//               sm: "repeat(3, 1fr)",
//               md: "repeat(4, 1fr)",
//               lg: "repeat(8, 1fr)",
//             },
//             maxWidth: { xs: "100%", sm: "100%", md: "900px", lg: "1550px" },
//             mx: "auto",
//             width: "100%",
//             gap: { xs: 1.2, sm: 1.5, md: 2, lg: 2 },
//             px: { xs: 2, sm: 3, md: 0 },
//           }}
//         >
//           {gridItems.map((item) => (
//             <Card
//               key={item.id}
//               onMouseEnter={() => setHoveredCard(item.id)}
//               onMouseLeave={() => setHoveredCard(null)}
//               onClick={() => {
//                 if (!item.isSpecial) {
//                   router.push("/free-trial-of-ai-recruiting-tool");
//                 } else if (item.id === 12 && item.title === "AI Recruiter") {
//                   router.push("/zayn-ai-recruiter/");
//                 }
//               }}
//               sx={{
//                 gridColumn: {
//                   xs: item.isSpecial ? "span 2" : "span 1",
//                   lg: item.isSpecial ? "span 2" : "span 1",
//                 },
//                 gridRow: {
//                   xs: item.isSpecial ? "span 2" : "span 1",
//                   lg: item.isSpecial ? "span 2" : "span 1",
//                 },
//                 borderRadius: { xs: 2, sm: 2, md: 2.5, lg: 3 },
//                 boxShadow:
//                   hoveredCard === item.id
//                     ? "0 8px 24px rgba(168, 85, 247, 0.25)"
//                     : "0 2px 8px rgba(0,0,0,0.08)",
//                 transition: "all 0.3s ease",
//                 cursor: "pointer",
//                 background: item.isSpecial
//                   ? item.bgColor
//                   : hoveredCard === item.id
//                     ? "linear-gradient(135deg, #faf5ff 0%, #ffffff 100%)"
//                     : "white",
//                 border:
//                   hoveredCard === item.id
//                     ? "2px solid #a855f7"
//                     : "2px solid transparent",
//                 transform:
//                   hoveredCard === item.id ? "translateY(-4px)" : "none",
//                 "&:hover": { "& .icon-image": { transform: "scale(1.1)" } },
//                 overflow: "hidden",
//               }}
//             >
//               <CardContent
//                 sx={{
//                   height: "100%",
//                   minHeight: item.isSpecial
//                     ? "auto"
//                     : {
//                       xs: "100px",
//                       sm: "110px",
//                       md: "10px",
//                       lg: "100px",
//                       xl: "170px",
//                     },
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   textAlign: "center",
//                   p: item.isSpecial
//                     ? "0 !important"
//                     : { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
//                   "&:last-child": {
//                     pb: item.isSpecial ? "0 !important" : undefined,
//                   },
//                 }}
//               >
//                 {item.isSpecial ? (
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: "100%",
//                       height: "100%",
//                       minHeight: {
//                         xs: "290px",
//                         sm: "370px",
//                         md: "360px",
//                         lg: "220px",
//                       },
//                       overflow: "hidden",
//                       borderRadius: { xs: 2, sm: 2, md: 2.5, lg: 3 },
//                     }}
//                   >
//                     <Image
//                       src={item.image}
//                       alt={item.title}
//                       fill
//                       style={{ objectFit: "cover", objectPosition: "center" }}
//                     />
//                   </Box>
//                 ) : (
//                   <>
//                     <Box
//                       className="icon-image"
//                       sx={{
//                         position: "relative",
//                         width: { xs: 26, sm: 30, md: 33, lg: 35 },
//                         height: { xs: 26, sm: 30, md: 33, lg: 35 },
//                         mb: { xs: 0.8, sm: 1, md: 1.5, lg: 2 },
//                         filter:
//                           hoveredCard === item.id
//                             ? "invert(41%) sepia(100%) saturate(440%) hue-rotate(222deg) brightness(95%) contrast(90%)"
//                             : "none",
//                       }}
//                     >
//                       <Image
//                         src={item.iconImg}
//                         alt={item.label}
//                         fill
//                         style={{ objectFit: "contain" }}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{
//                         fontSize: {
//                           xs: "11px",
//                           sm: "12px",
//                           md: "13px",
//                           lg: "14px",
//                           xl: "15px",
//                         },
//                         fontWeight: 500,
//                         color: hoveredCard === item.id ? "#a855f7" : "#6b7280",
//                         transition: "color 0.3s ease",
//                         fontFamily: "var(--font-outfit)",
//                         lineHeight: 1.3,
//                       }}
//                     >
//                       {item.label}
//                     </Typography>
//                   </>
//                 )}
//               </CardContent>
//             </Card>
//           ))}
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             gap: { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
//             mt: { xs: "4%", sm: "5%", md: "5%", lg: "3%" },
//             flexWrap: "wrap",
//           }}
//         >
//           <NextLink href="/features" passHref legacyBehavior>
//             <Button
//               component="a"
//               sx={{
//                 bgcolor: "#9A56FF",
//                 color: "white",
//                 px: { xs: 2, sm: 2.3, md: 2.5, lg: 3 },
//                 py: { xs: 1, sm: 1.1, md: 1.2, lg: 1.4 },
//                 borderRadius: "50px",
//                 textTransform: "none",
//                 fontSize: { xs: "13px", sm: "14px", md: "15px", lg: "16px" },
//                 fontWeight: 400,
//                 fontFamily: "var(--font-outfit)",
//                 transition: "all 0.2s ease-in-out",
//                 "&:hover": {
//                   bgcolor: "#9A56FF",
//                   transform: "scale(1.05) translateY(-2px)",
//                 },
//               }}
//             >
//               {t("aiToolkit.viewAllFeatures")}
//             </Button>
//           </NextLink>

//           <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
//             <Button
//               component="a"
//               sx={{
//                 bgcolor: "#000",
//                 color: "white",
//                 px: { xs: 2, sm: 2.3, md: 2.5, lg: 3 },
//                 py: { xs: 1, sm: 1.1, md: 1.2, lg: 1.4 },
//                 borderRadius: "50px",
//                 textTransform: "none",
//                 fontSize: { xs: "13px", sm: "14px", md: "15px", lg: "16px" },
//                 fontWeight: 400,
//                 fontFamily: "var(--font-outfit)",
//                 transition: "all 0.2s ease-in-out",
//                 "&:hover": {
//                   bgcolor: "#000",
//                   transform: "scale(1.05) translateY(-2px)",
//                 },
//               }}
//             >
//               {t("aiToolkit.bookDemo")}
//             </Button>
//           </NextLink>
//         </Box>
//         {/* Feedback Section */}
//         <Box
//           sx={{
//             ml: { xs: "-5%", lg: "-4%" },
//             mr: { xs: "-5%", lg: "-4%" },
//             mt: { xs: "6%", sm: "5%", md: "4%", lg: "5%" },
//           }}
//         >
//           {/* <RecruiterFeedback /> */}
//           <HiringProcess />
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default FeaturesGrid;


"use client";
import React, { useState } from "react";
import { Box, Container, Typography, Card, CardContent, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import RecruiterFeedback from "./RecruiterFeedback";
import "../app/globals.css";
import { IMAGES } from "../constants/images";
import HiringProcess from "./HiringProcess";
import NextLink from "next/link";

const FeaturesGrid = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const gridItems = [
    {
      id: 1,
      iconImg: IMAGES.FEATURE_ICON_1,
      label: t("featuresGrid.items.aiRecruiter"),
    },
    {
      id: 2,
      iconImg: IMAGES.FEATURE_ICON_2,
      label: t("featuresGrid.items.evaluationEngine"),
    },
    {
      id: 3,
      iconImg: IMAGES.FEATURE_ICON_3,
      label: t("featuresGrid.items.aiScreening"),
    },
    {
      id: 4,
      iconImg: IMAGES.FEATURE_ICON_4,
      label: t("featuresGrid.items.candidateMatchmaking"),
    },
    {
      id: 5,
      iconImg: IMAGES.FEATURE_ICON_5,
      label: t("featuresGrid.items.aiCandidateScoring"),
    },
    {
      id: 6,
      iconImg: IMAGES.FEATURE_ICON_6,
      label: t("featuresGrid.items.multilingualInterviews"),
    },
    {
      id: 7,
      iconImg: IMAGES.FEATURE_ICON_7,
      label: t("featuresGrid.items.interviewSummaries"),
    },
    {
      id: 8,
      iconImg: IMAGES.FEATURE_ICON_8,
      label: t("featuresGrid.items.customInterviews"),
    },
    {
      id: 9,
      iconImg: IMAGES.FEATURE_ICON_9,
      label: t("featuresGrid.items.customBranding"),
    },
    {
      id: 10,
      iconImg: IMAGES.FEATURE_ICON_10,
      label: t("featuresGrid.items.advancedAnalytics"),
    },
    {
      id: 11,
      isSpecial: true,
      image: isArabic
        ? IMAGES.EVALUATION_ENGINE_ARABIC
        : IMAGES.EVALUATION_ENGINE,
      title: "Evaluation Engine",
    },
    {
      id: 12,
      isSpecial: true,
      image: isArabic
        ? IMAGES.AI_RECRUITER_FEATURE_ARABIC
        : IMAGES.AI_RECRUITER_FEATURE,
      title: "AI Recruiter",
    },
    {
      id: 13,
      iconImg: IMAGES.FEATURE_ICON_11,
      label: t("featuresGrid.items.emailAutomation"),
    },
    {
      id: 14,
      iconImg: IMAGES.FEATURE_ICON_12,
      label: t("featuresGrid.items.careersPage"),
    },
    {
      id: 15,
      iconImg: IMAGES.FEATURE_ICON_13,
      label: t("featuresGrid.items.bulkHiring"),
    },
    {
      id: 16,
      iconImg: IMAGES.FEATURE_ICON_14,
      label: t("featuresGrid.items.assessmentLibrary"),
    },
    {
      id: 17,
      iconImg: IMAGES.FEATURE_ICON_15,
      label: t("featuresGrid.items.interviewScheduling"),
    },
    {
      id: 18,
      iconImg: IMAGES.FEATURE_ICON_16,
      label: t("featuresGrid.items.mobileOptimization"),
    },
    {
      id: 19,
      iconImg: IMAGES.FEATURE_ICON_17,
      label: t("featuresGrid.items.recruitingAnalytics"),
    },
    {
      id: 20,
      iconImg: IMAGES.FEATURE_ICON_18,
      label: t("featuresGrid.items.customAutomations"),
    },
    {
      id: 21,
      iconImg: IMAGES.FEATURE_ICON_20,
      label: t("featuresGrid.items.calendarIntegration"),
    },
    {
      id: 22,
      iconImg: IMAGES.FEATURE_ICON_21,
      label: t("featuresGrid.items.antiCheating"),
    },
    {
      id: 23,
      iconImg: IMAGES.FEATURE_ICON_22,
      label: t("featuresGrid.items.referenceChecking"),
    },
    {
      id: 24,
      iconImg: IMAGES.FEATURE_ICON_23,
      label: t("featuresGrid.items.backgroundVerification"),
    },
    {
      id: 25,
      iconImg: IMAGES.FEATURE_ICON_24,
      label: t("featuresGrid.items.customEmails"),
    },
    {
      id: 26,
      iconImg: IMAGES.FEATURE_ICON_25,
      label: t("featuresGrid.items.offerLetter"),
    },
  ];

  const getHref = (item) => {
    if (!item.isSpecial) return "/free-trial-of-ai-recruiting-tool";
    if (item.id === 12 && item.title === "AI Recruiter") return "/zayn-ai-recruiter";
    return null;
  };

  return (
    <Box
      sx={{
        backgroundImage: `url('${IMAGES.FEATURES_GRID_BG}')`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="xxl">
        {/* Header */}
        <Box
          sx={{
            textAlign: {
              xs: "left",
              sm: "left",
              md: "left",
              lg: "center",
              xl: "center",
            },
            mb: { xs: 3, sm: 4, md: 5, lg: 8 },
            px: { xs: 2, sm: 3, md: 0 },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: {
                xs: "22px",
                sm: "26px",
                md: "32px",
                lg: "40px",
                xl: "48px",
              },
              fontWeight: 700,
              lineHeight: isArabic ? 1.6 : 1.3,
              color: "#020617",
              mb: { xs: 1, sm: 1.2, md: 1.5 },
              fontFamily: "var(--font-plusjakarta)",
              pt: { xs: "8%", sm: "7%", md: "6%", lg: "6%" },
              textAlign: {
                xs: isArabic ? "right" : "left",
                sm: isArabic ? "right" : "left",
                md: isArabic ? "right" : "left",
                lg: "center",
                xl: "center",
              },
              "& span": { color: "inherit" },
            }}
          >
            {isArabic ? (
              <>
                <span style={{ color: "#9048FB", fontStyle: "normal" }}>
                  {"و"}
                </span>{" "}
                <span
                  style={{
                    color: "#9048FB",
                    fontStyle: "normal",
                    WebkitTextFillColor: "#9048FB",
                    background: "none",
                  }}
                >
                  {"أكثر"}
                </span>{" "}
                <span style={{ color: "#020617", fontStyle: "normal" }}>
                  {"من ذلك بكثير"}
                </span>{" "}
                <span style={{ color: "#020617" }}>{"."}</span>
                <span
                  style={{
                    color: "#9048FB",
                    WebkitTextFillColor: "#9048FB",
                    background: "none",
                  }}
                >
                  {"."}
                </span>
                <span style={{ color: "#020617" }}>{"."}</span>
              </>
            ) : (
              <>
                <span style={{ color: "#020617" }}>{"."}</span>
                <span
                  style={{
                    color: "#9048FB",
                    WebkitTextFillColor: "#9048FB",
                    background: "none",
                  }}
                >
                  {"."}
                </span>
                <span style={{ color: "#020617" }}>{"."}</span>
                {" and "}
                <span
                  style={{
                    color: "#9048FB",
                    WebkitTextFillColor: "#9048FB",
                    background: "none",
                  }}
                >
                  {"much "}
                </span>
                <span style={{ color: "#020617" }}>{"more"}</span>
              </>
            )}
          </Typography>
          <Typography
            sx={{
              color: "#02061799",
              mb: 0.7,
              fontWeight: "400",
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "17px",
                lg: "20px",
                xl: "22px",
              },
              fontFamily: "var(--font-outfit)",
              mx: { xs: 0, sm: 0, md: 0, lg: "auto" },
              textAlign: isArabic
                ? { xs: "right", lg: "center" }
                : { xs: "left", lg: "center" },
              maxWidth: { xs: "100%", lg: 900 },
              mt: { xs: isArabic ? "3%" : ".5%", sm: ".5%" },
              lineHeight: 1.4,
            }}
          >
            {t("featuresGrid.subtitle")}
          </Typography>
        </Box>

        {/* Grid Section */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(3, 1fr)",
              md: "repeat(4, 1fr)",
              lg: "repeat(8, 1fr)",
            },
            maxWidth: { xs: "100%", sm: "100%", md: "900px", lg: "1550px" },
            mx: "auto",
            width: "100%",
            gap: { xs: 1.2, sm: 1.5, md: 2, lg: 2 },
            px: { xs: 2, sm: 3, md: 0 },
          }}
        >
          {gridItems.map((item) => {
            const href = getHref(item);

            return (
              <Card
                key={item.id}
                {...(href
                  ? { component: NextLink, href, rel: "noopener noreferrer" }
                  : {})}
                onMouseEnter={() => setHoveredCard(item.id)}
                onMouseLeave={() => setHoveredCard(null)}
                sx={{
                  textDecoration: "none",
                  gridColumn: {
                    xs: item.isSpecial ? "span 2" : "span 1",
                    lg: item.isSpecial ? "span 2" : "span 1",
                  },
                  gridRow: {
                    xs: item.isSpecial ? "span 2" : "span 1",
                    lg: item.isSpecial ? "span 2" : "span 1",
                  },
                  borderRadius: { xs: 2, sm: 2, md: 2.5, lg: 3 },
                  boxShadow:
                    hoveredCard === item.id
                      ? "0 8px 24px rgba(168, 85, 247, 0.25)"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  cursor: href ? "pointer" : "default",
                  background: item.isSpecial
                    ? item.bgColor
                    : hoveredCard === item.id
                      ? "linear-gradient(135deg, #faf5ff 0%, #ffffff 100%)"
                      : "white",
                  border:
                    hoveredCard === item.id
                      ? "2px solid #a855f7"
                      : "2px solid transparent",
                  transform:
                    hoveredCard === item.id ? "translateY(-4px)" : "none",
                  "&:hover": { "& .icon-image": { transform: "scale(1.1)" } },
                  overflow: "hidden",
                }}
              >
                <CardContent
                  sx={{
                    height: "100%",
                    minHeight: item.isSpecial
                      ? "auto"
                      : {
                        xs: "100px",
                        sm: "110px",
                        md: "10px",
                        lg: "100px",
                        xl: "170px",
                      },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    p: item.isSpecial
                      ? "0 !important"
                      : { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
                    "&:last-child": {
                      pb: item.isSpecial ? "0 !important" : undefined,
                    },
                  }}
                >
                  {item.isSpecial ? (
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        minHeight: {
                          xs: "290px",
                          sm: "370px",
                          md: "360px",
                          lg: "220px",
                        },
                        overflow: "hidden",
                        borderRadius: { xs: 2, sm: 2, md: 2.5, lg: 3 },
                      }}
                    >
                      <Image
                        src={item.image}
                        alt={item.title}
                        fill
                        style={{ objectFit: "cover", objectPosition: "center" }}
                      />
                    </Box>
                  ) : (
                    <>
                      <Box
                        className="icon-image"
                        sx={{
                          position: "relative",
                          width: { xs: 26, sm: 30, md: 33, lg: 35 },
                          height: { xs: 26, sm: 30, md: 33, lg: 35 },
                          mb: { xs: 0.8, sm: 1, md: 1.5, lg: 2 },
                          filter:
                            hoveredCard === item.id
                              ? "invert(41%) sepia(100%) saturate(440%) hue-rotate(222deg) brightness(95%) contrast(90%)"
                              : "none",
                        }}
                      >
                        <Image
                          src={item.iconImg}
                          alt={item.label}
                          fill
                          style={{ objectFit: "contain" }}
                        />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "11px",
                            sm: "12px",
                            md: "13px",
                            lg: "14px",
                            xl: "15px",
                          },
                          fontWeight: 500,
                          color: hoveredCard === item.id ? "#a855f7" : "#6b7280",
                          transition: "color 0.3s ease",
                          fontFamily: "var(--font-outfit)",
                          lineHeight: 1.3,
                        }}
                      >
                        {item.label}
                      </Typography>
                    </>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2, md: 2.5, lg: 3 },
            mt: { xs: "4%", sm: "5%", md: "5%", lg: "3%" },
            flexWrap: "wrap",
          }}
        >
          <NextLink href="/features" passHref legacyBehavior>
            <Button
              component="a"
              sx={{
                bgcolor: "#9A56FF",
                color: "white",
                px: { xs: 2, sm: 2.3, md: 2.5, lg: 3 },
                py: { xs: 1, sm: 1.1, md: 1.2, lg: 1.4 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "13px", sm: "14px", md: "15px", lg: "16px" },
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#9A56FF",
                  transform: "scale(1.05) translateY(-2px)",
                },
              }}
            >
              {t("aiToolkit.viewAllFeatures")}
            </Button>
          </NextLink>

          <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
            <Button
              component="a"
              sx={{
                bgcolor: "#000",
                color: "white",
                px: { xs: 2, sm: 2.3, md: 2.5, lg: 3 },
                py: { xs: 1, sm: 1.1, md: 1.2, lg: 1.4 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "13px", sm: "14px", md: "15px", lg: "16px" },
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#000",
                  transform: "scale(1.05) translateY(-2px)",
                },
              }}
            >
              {t("aiToolkit.bookDemo")}
            </Button>
          </NextLink>
        </Box>

        {/* Feedback Section */}
        <Box
          sx={{
            ml: { xs: "-5%", lg: "-4%" },
            mr: { xs: "-5%", lg: "-4%" },
            mt: { xs: "6%", sm: "5%", md: "4%", lg: "5%" },
          }}
        >
          {/* <RecruiterFeedback /> */}
          <HiringProcess />
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturesGrid;